(function()
{
	function View()
	{
		this.Container_constructor();
	}

	var p = createjs.extend(View, cjs.Container);

	p.reset = function()
	{
		this.resize(cm.app.display.stage.canvas.width, cm.app.display.stage.canvas.height);
	};

	p.start = function()
	{
		this.setActive(true);
	};

	p.setActive = function( bool )
	{

	};

	p.animateIn = function()
	{
		// return cm.ViewControl.transitOut();
	};

	p.animateOut = function()
	{
		this.setActive(false);
		// return cm.ViewControl.transitIn();
	};

	p.resize = function( width, height )
	{
	};

	p.update = function()
	{
	};

	p.destroy = function()
	{
		this.setActive(false);
	};

	cm.View = cjs.promote(View, "Container");

})();